import { Component, inject, Inject, OnInit, signal } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogModule,
} from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MyErrorStateMatcher } from '../../../lot-new/new-lot.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatDivider } from '@angular/material/divider';
import { CommonModule } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
  futuresMonths,
  futuresYears,
  PriceType,
  PriceUnion,
} from '../../../lots.model';
import { MatSelectModule } from '@angular/material/select';
import { counterPriceValidator } from 'src/app/components/custom/form-validators/counter-price.validator';
import { Analytics, logEvent } from '@angular/fire/analytics';
import { LogEventsEnum } from 'src/app/firebase.model';
import { LotsService } from 'src/app/services/lots.service';
export interface CounterDialogData {
  form: FormGroup;
  lotId: string;
  dialogTitle?: string | null;
  dialogType: DialogType;
}

export enum DialogType {
  Edit = 'Edit',
  Counter = 'Counter',
}

@Component({
  selector: 'app-counter-dialog-template',
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatRadioModule,
    MatDialogModule,
    MatDivider,
  ],
  templateUrl: './lot-action-dialog-template.component.html',
  styleUrl: './lot-action-dialog-template.component.css',
})
export class LotActionDialogTemplateComponent implements OnInit {
  private analytics = inject(Analytics);
  priceTypes = PriceType;
  dialogTypes = DialogType;
  matcher = new MyErrorStateMatcher();
  minDate = new Date();
  basisQuote = signal<string>(null);

  dialogType = signal<DialogType>(null);

  basisMonths = futuresMonths;
  basisYears = futuresYears();

  form = this.fb.group(
    {
      lot_id: [''],
      price_type: [''],
      cash_price: this.fb.group({
        amount: [0, [Validators.pattern(/^[0-9]\d*(\.\d{1,4})?$/)]],
      }),
      basis_price: this.fb.group({
        basisPoints: [0, [Validators.pattern(/^-?\d+(\.\d{0,4})?$/)]],
        month: [''],
        product_code: [''],
        year: [0],
      }),
      volume_value: [
        0,
        [
          Validators.required,
          Validators.pattern(/^[1-9]\d*$/),
          Validators.min(1),
        ],
      ],
      ship_begin: [''],
      ship_end: [''],
    },
    { validators: counterPriceValidator() }
  );

  constructor(
    public dialogRef: MatDialogRef<LotActionDialogTemplateComponent>,
    private fb: FormBuilder,
    private lotsService: LotsService,
    @Inject(MAT_DIALOG_DATA) public data: CounterDialogData
  ) {
    this.dialogRef.disableClose = true;
    this.minDate.setHours(0, 0, 0, 0);
  }

  ngOnInit(): void {
    logEvent(this.analytics, LogEventsEnum.negotiations_form_view);
    this.form.get('basis_price').valueChanges.subscribe({
      next: (value) => {
        if (value.product_code) {
          this.basisQuote.set(
            `${this.lotsService.getPriceText(value)}${value.product_code}${
              value.month
            }${value.year % 100}`
          );
        } else {
          this.basisQuote.set('');
        }
      },
    });
    this.form.patchValue({
      ...this.data.form.value,
      lot_id: this.data.lotId,
    });

    this.dialogType.set(this.data.dialogType);
  }

  close(submit: boolean) {
    this.dialogRef.close({ confirm: submit, data: this.form.value });
  }
}
